import { Platform, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { ChevronRightIcon } from '../../../components/ui/ChevronRightIcon'
import { symbolName } from '../../../components/ui/Icon'
import { Spinner } from '../../../components/ui/Spinner'
import { StarsIcon } from '../../../components/ui/StarsIcon'
import { colors } from '../../../theme'
import { SettingsCard, SettingsRow } from './SettingsPrimitives'

type SubscriptionSettingsCardProps = {
  isCustomerInfoPending: boolean
  hasActiveSubscription: boolean
  isSubscriptionCancelled: boolean
  subscriptionSubtitle: string
  onManageSubscription: () => void
  isManagingSubscription: boolean
  onSubscribe: () => void
  onRestorePurchase: () => void
  isRestorePending: boolean
}

export function SubscriptionSettingsCard({
  isCustomerInfoPending,
  hasActiveSubscription,
  isSubscriptionCancelled,
  subscriptionSubtitle,
  onManageSubscription,
  isManagingSubscription,
  onSubscribe,
  onRestorePurchase,
  isRestorePending,
}: SubscriptionSettingsCardProps) {
  const { t } = useTranslation(['profile'])
  const isWeb = Platform.OS === 'web'

  return (
    <SettingsCard className="mb-6">
      {isCustomerInfoPending ? (
        <View className="items-center px-5 py-6">
          <Spinner color={colors.inkSecondary} />
        </View>
      ) : hasActiveSubscription && isSubscriptionCancelled ? (
        <SettingsRow
          leadingIcon={<StarsIcon color={colors.primary100} />}
          label={t('profile:manage_subscription')}
          subtitle={subscriptionSubtitle}
          onPress={onManageSubscription}
          isLoading={isManagingSubscription}
          labelColor={colors.primary100}
          accessoryIcon={<ChevronRightIcon color={colors.muted} />}
          isLast={isWeb}
        />
      ) : hasActiveSubscription ? (
        <SettingsRow
          leadingIcon={<StarsIcon />}
          label={t('profile:manage_subscription')}
          subtitle={subscriptionSubtitle}
          onPress={onManageSubscription}
          isLoading={isManagingSubscription}
          isLast={isWeb}
        />
      ) : (
        <SettingsRow
          leadingIcon={<StarsIcon />}
          label={t('profile:subscribe')}
          subtitle={subscriptionSubtitle}
          onPress={onSubscribe}
          isLast={isWeb}
        />
      )}

      {!isWeb ? (
        <SettingsRow
          icon={symbolName('arrow.clockwise', 'refresh')}
          label={t('profile:restore_purchases')}
          subtitle={t('profile:restore_purchases_hint')}
          onPress={onRestorePurchase}
          isLoading={isRestorePending}
          isLast
        />
      ) : null}
    </SettingsCard>
  )
}
